import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import ConfirmationButton from "../../ConfirmationButton/index.jsx";

class GoalItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      showActions: false,
      editDescription: this.props.goal.description,
    };

    this.editInputRef = React.createRef();
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  handleClickOutside(event) {
    if (this.state.showActions && this.containerRef.current && !this.containerRef.current.contains(event.target)) {
      setTimeout(() => {
        this.setState({ showActions: false });
      }, 0);
    }
  }

  toggleActions() {
    this.setState({ showActions: !this.state.showActions });
  }

  startEditing() {
    this.setState(
      {
        isEditing: true,
        showActions: false,
        editDescription: this.props.goal.description,
      },
      () => {
        if (this.editInputRef.current) {
          this.editInputRef.current.focus();
        }
      }
    );
  }

  cancelEditing() {
    this.setState({
      isEditing: false,
      editDescription: this.props.goal.description,
    });
  }

  saveEdit() {
    if (!this.state.editDescription.trim()) {
      alert("Please enter a goal description");
      return;
    }

    const updatedGoal = {
      ...this.props.goal,
      description: this.state.editDescription.trim(),
    };

    this.props.onEdit(updatedGoal);
    this.setState({ isEditing: false });
  }

  handleKeyPress(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.saveEdit();
    } else if (e.key === "Escape") {
      this.cancelEditing();
    }
  }

  render() {
    const { goal, onDelete, onComplete } = this.props;
    const isCompleted = goal.status === "completed";

    if (this.state.isEditing) {
      return (
        <div ref={this.containerRef}>
          <li className="">
            <Row className="align-items-start">
              <Col md={8}>
                <Form.Control
                  ref={this.editInputRef}
                  type="text"
                  value={this.state.editDescription}
                  onChange={(e) => this.setState({ editDescription: e.target.value })}
                  onKeyDown={(e) => this.handleKeyPress(e)}
                  placeholder="Enter goal description..."
                />
                <Form.Text className="text-muted">Press Enter to save, Escape to cancel</Form.Text>
              </Col>
              <Col md={4} className="text-right pt-1">
                <Button variant="very-very-good" className="mr-2" onClick={() => this.saveEdit()}>
                  Save
                </Button>
                <Button variant="secondary" onClick={() => this.cancelEditing()}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </li>
        </div>
      );
    }

    return (
      <div ref={this.containerRef}>
        <li className={`${isCompleted ? "text-success" : ""}`}>
          <Row className="align-items-center">
            <Col md={10}>
              <p
                style={{
                  textDecoration: isCompleted ? "line-through" : "none",
                }}
              >
                {goal.description}
              </p>
            </Col>
            <Col md={2} className="text-right">
              <Button variant="button" size="sm" onClick={() => this.toggleActions()} title="Actions" className="p-1">
                <i className="fas fa-ellipsis"></i>
              </Button>
            </Col>
          </Row>
        </li>

        {this.state.showActions && (
          <div className="pt-0">
            <div className="text-right">
              {!isCompleted && (
                <>
                  <Button variant="dark" className="mr-2" onClick={() => this.startEditing()}>
                    Edit Goal
                  </Button>
                  <Button
                    variant="very-very-good"
                    className="mr-2"
                    onClick={() => {
                      onComplete(goal.id);
                      this.setState({ showActions: false });
                    }}
                  >
                    Complete Goal
                  </Button>
                </>
              )}
              <ConfirmationButton
                variant="danger"
                buttonText={<React.Fragment>Delete Goal</React.Fragment>}
                modalTitle="Delete Goal"
                modalBody="Are you sure you want to delete this goal? This action cannot be undone."
                confirmVariant="danger"
                buttonConfirmText="Yes, delete"
                onConfirm={() => {
                  onDelete(goal.id);
                  this.setState({ showActions: false });
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default GoalItem;
